import { render, staticRenderFns } from "./secrethistory.vue?vue&type=template&id=200f4029&"
import script from "./secrethistory.vue?vue&type=script&lang=js&"
export * from "./secrethistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports